import React from 'react';
import { Outlet } from 'react-router-dom';

const SettingsLayout = () => {
  return <Outlet />;
};

export default SettingsLayout;
